import "./TimeSheetCategoryTrackingFieldsStyle.css";

import { Typography, useTheme } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedRadioGroupRHF, RHookFormTextField } from "@websential/cosmic-v20";
import { TimeSheetCategoryTrackingFieldsHeader } from "../TimeSheetCategoryTrackingFieldsTable/TimeSheetCategoryTrackingFieldsTableHeader";
import { InputText } from "primereact/inputtext";
import { Padding } from "@mui/icons-material";


let columns = [
  { field: "categoryTrackingLabel", },
  { field: "addJobsProjectToTrack" },
];

let emptyCategoryTrackingFields = {
  id: null,
  categoryTrackingLabel: null,
  addJobsProjectToTrack: null,
}

interface ITimeSheetCategoryTrackingFieldsTable {
  categoryTrackingTableUpdatedData: (data: any) => void;
  categoryTrackingFieldsDataItems: any;
}
export const TimeSheetCategoryTrackingFieldsTable: FC<
  ITimeSheetCategoryTrackingFieldsTable
> = ({ categoryTrackingTableUpdatedData, categoryTrackingFieldsDataItems }) => {

  const [categoryTrackingTable, setCategoryTrackingTable] = useState<any>(
    categoryTrackingFieldsDataItems
  );

  // const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  const newRowIdsRef = useRef<Set<any>>(new Set());
  const [categoryTrackingFieldEmpty, setCategoryTrackingFieldEmpty] = useState(emptyCategoryTrackingFields);

  useEffect(() => {
    categoryTrackingTableUpdatedData(categoryTrackingTable);
  }, [categoryTrackingTable]);

  useEffect(() => {
    setCategoryTrackingTable(categoryTrackingFieldsDataItems);
  }, [categoryTrackingFieldsDataItems]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < categoryTrackingTable.length; i++) {
      if (categoryTrackingTable[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  const openNew = () => {
    // if (categoryTrackingTable && categoryTrackingTable.length >= 10) return null;
    let _categoryTrackingPanelData = [...categoryTrackingTable];
    let _categoryTrackingPanelNewRow: any = { ...categoryTrackingFieldEmpty };

    if (categoryTrackingFieldEmpty.id) {
      const rowIndex = findIndexById(categoryTrackingFieldEmpty.id);
      _categoryTrackingPanelData[rowIndex] = _categoryTrackingPanelNewRow;

    }
    else {
      const newRowId = createId();
      _categoryTrackingPanelNewRow.id = newRowId;
      _categoryTrackingPanelData.push(_categoryTrackingPanelNewRow);
      // setLastAddedRowId(newRowId && newRowId);
      newRowIdsRef.current.add(newRowId);   // same setLastAddedRowId(newRowId)
      console.log("New Row", newRowId);
      console.log("Rows", _categoryTrackingPanelData);
    }
    setCategoryTrackingTable(_categoryTrackingPanelData);
    setCategoryTrackingFieldEmpty(emptyCategoryTrackingFields);
  };


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {

    setCategoryTrackingTable((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  //   const onDeleteNewAddedRow = (rowId: any) => {
  //     setCategoryTrackingTable((prev: any[]) => {
  //       // const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

  //       // if (rowDeleteBasedOnId.length > 1) {
  //       //   const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
  //       //   setLastAddedRowId(lastRowId);
  //       // } else {
  //       //   setLastAddedRowId(null);
  //       // }
  //          newRowIdsRef.current.delete(rowId);
  // +    const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);
  //       return rowDeleteBasedOnId;
  //     });
  //   }
  const onDeleteNewAddedRow = (rowId: any) => {
    newRowIdsRef.current.delete(rowId);
    setCategoryTrackingTable((prev: any[]) =>
      prev.filter((row) => row.id !== rowId)
    );
  };

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "addJobsProjectToTrack") {
      if (
        rowData.addJobsProjectToTrack !== "" &&
        rowData.addJobsProjectToTrack !== undefined &&
        rowData.addJobsProjectToTrack !== null
      ) {
        if (rowData.addJobsProjectToTrack === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.addJobsProjectToTrack === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "addJobsProjectToTrack") {
      if (
        rowData.addJobsProjectToTrack !== "" &&
        rowData.addJobsProjectToTrack !== undefined &&
        rowData.addJobsProjectToTrack !== null
      ) {
        if (rowData.addJobsProjectToTrack === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.addJobsProjectToTrack === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };
  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "categoryTrackingLabel") {
      return (
        <Typography sx={{ fontSize: ".875rem", padding: 0, fontWeight: "300" }}>
          Add jobs / Projects to Track
        </Typography>
      );
    } else if (x.field === "addJobsProjectToTrack") {
      return (
        <InputText
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
          className={renderErrorClass(x, row.rowIndex, rowData)}
          style={{ paddingTop: "5px!important", paddingBottom: "5px!important", margin: 0 }}
        />
      );
    }
  };



  return (
    <>
      <div className="card">
        <TimeSheetCategoryTrackingFieldsHeader
          openNew={openNew}
        // selectedFieldPanelLabel={"Hello"}
        />
        <DataTable
          value={categoryTrackingTable}
          dataKey="id"
          // key={lastAddedRowId}
          showGridlines
          className="TimeSheetCategoryTrackingFieldsStyle"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
        // scrollHeight="416px"
        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                columnKey={x.field}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
          <Column
            body={(rowData: any) => {
              const showIcon = newRowIdsRef.current.has(rowData.id);
              return showIcon ? (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent delete-row-btn"
                  rounded
                  onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
                />
              ) : null;
            }}
             bodyClassName={(rowData: any) =>
              newRowIdsRef.current.has(rowData.id) ? "delete-cell" : ""
            }
          />
        </DataTable>
      </div>
    </>
  );
};
